<template>
    <div
        class="relative my-[-1px] before:absolute before:top-0 before:bottom-0 before:left-0 before:w-[calc(50vw+220px)] before:bg-(--ui-bg-white)"
    >
        <div class="relative z-5">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
/**
 * OffsetBackground Component
 *
 * Creates a white background that extends from the left edge of the viewport,
 * offset by a calculated width (50vw + 220px). This creates a visual separation
 * effect where content appears to sit on a white background panel that extends
 * from the left side of the screen.
 *
 * Use Case:
 * Used to create a distinctive layout where content sections have a white
 * background that extends from the left edge, providing visual hierarchy
 * and separation from the main page background.
 *
 * How it works:
 * - Uses a pseudo-element (::before) to create the background layer
 * - The background width is calculated as `calc(50vw + 220px)` to extend
 *   from the left edge with a specific offset
 * - Content is wrapped in a relative positioned div with z-index to sit
 *   above the background layer
 *
 * Example usage:
 * ```vue
 * <OffsetBackground>
 *   <UContainer>
 *     <YourContent />
 *   </UContainer>
 * </OffsetBackground>
 * ```
 */
</script>
